import { useI18n } from "vue-i18n";

import { useMutation } from "@tanstack/vue-query";

import { useNotification } from "@/hooks/notifications";
import { queryClient } from "@/query/queryClient";
import myApiService from "@/services/modules/my";

import type {
  AudioDeviceResponse,
  EmailTypeResponse,
  PhoneNumberResponse,
  PhoneProviderResponse,
  UpdateAudioDevicePayload,
  UpdateEmailTypePayload,
  UpdatePhoneNumberRoutingPayload,
} from "@/models/preferences";

const QUERY_KEYS = {
  preferences: () => ["preferences"],
} as const;

export const usePreferencesMutation = () => {
  const { showMessage } = useNotification();
  const { t } = useI18n();
  return useMutation({
    mutationFn: (
      preferences: (
        | UpdateEmailTypePayload
        | UpdatePhoneNumberRoutingPayload
        | UpdateAudioDevicePayload
      )[]
    ): Promise<
      (
        | EmailTypeResponse
        | PhoneNumberResponse
        | PhoneProviderResponse
        | AudioDeviceResponse
      )[]
    > => {
      return Promise.all(
        preferences.map((preference) =>
          myApiService.savePreferences(preference)
        )
      );
    },
    onSuccess: () => {
      showMessage(t("ACCOUNT.PREFERENCE.SUCCESS_MESSAGE"), "success");
      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.preferences(),
      });
    },
  });
};
